import { AppComponent } from './app.component';

// Angular
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthGuard } from '@acpgruppe/essp-ui';
import { AuthConfigService } from '@acpgruppe/essp-ui';
import { PermissionGuard } from '@acpgruppe/essp-ui';
import { environment } from 'src/environments/environment';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { EsspThemeConfiguration } from '@acpgruppe/essp-ui';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    OAuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [
    AuthGuard,
    AuthConfigService,
    PermissionGuard,
    provideAppInitializer(() => {
      const initializerFn = (
        (initialAuthService: AuthConfigService) => () =>
          initialAuthService.initAuth(environment)
      )(inject(AuthConfigService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: EsspThemeConfiguration,
    }),
  ],
})
export class AppModule {}
